import "./PersonalInformation.css";
import { useContext } from "react";
import { UserContext } from "../../../../context/UserContext";
import profile from "../../../../../assets/settings-profile.png";

const PersonalInformation = ({ setActive }) => {
 const { user } = useContext(UserContext);
 return (
  <div className="personal-information">
   <div className="profile">
    <div className="img-container">
     <img src={profile} alt="profile" />
    </div>
    <div className="name-container">
     <p className="title">
      {user.firstName} {user.lastName}
     </p>
     <p onClick={() => setActive("editpersonalinformation")}>Go to profile</p>
    </div>
   </div>
   <div className="info-container">
    <div className="item">
     <p>Legal name</p>
     <p style={{ textTransform: "capitalize" }}>
      {" "}
      {user.firstName} {user.lastName}
     </p>
    </div>
    <div className="item">
     <p>Email address</p>
     <p> {user.email}</p>
    </div>

    <div className="item">
     <p>Phone number</p>
     <p>{user.phoneNumber}</p>
    </div>

    <div className="item">
     <p>Gender</p>
     {user.gender ? <p>{user.gender}</p> : "Not specified"}
    </div>

    <div className="item">
     <p>Date of birth</p>
     <p>06/08/1997</p>
    </div>

    <div className="item">
     <p>Address</p>
     <p>Not specified</p>
    </div>

    <div className="item">
     <p>Government ID</p>
     <p>English</p>
    </div>
   </div>
  </div>
 );
};

export default PersonalInformation;
